export interface PollOptions {
  intervalMs: number;
  maxAttempts: number;
}

export const pollUntil = async (
  attempt: () => Promise<boolean>,
  { intervalMs, maxAttempts }: PollOptions,
): Promise<void> => {
  for (let i = 0; i < maxAttempts; i++) {
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
    if (await attempt()) return;
  }
};
